import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2c71f058"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"background-color":"var(--os-blue)"},
  class: "py-md"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-body os-semibold" }, " Instala nuestra app. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "os-bold" }, "ONE", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SPOT", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label" }, "Correo electrónico", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label" }, "Contraseña", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"height":"1px","background-color":"lightgrey","margin":"5px"} }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Regístrate", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/terms-and-conditions/user-register",
    target: "_blank",
    class: "text-os-pink"
  }, "Términos y condiciones"),
  /*#__PURE__*/_createTextVNode(" para registro de usuario ")
], -1))
const _hoisted_15 = { class: "text-body" }
const _hoisted_16 = { class: "os-bold" }
const _hoisted_17 = { class: "text-caption mb-md" }
const _hoisted_18 = { class: "pa-md" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 os-semibold text-center mb-lg" }, " Iniciar sesión ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label" }, "Correo electrónico", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label" }, "Contraseña", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"height":"1px","background-color":"lightgrey","margin":"5px"} }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Regístrate", -1))
const _hoisted_24 = [
  _hoisted_23
]

import { ref, onBeforeMount, computed } from "vue";
import { personCircleOutline, ticketOutline } from "ionicons/icons";
import { useRoute } from "vue-router";

// STORES
import { storeToRefs } from "pinia";
import { useAppStore } from "@/stores/AppStore";
import { useAuthStore } from "@/stores/AuthStore";
import {
  IonPage,
  IonRouterOutlet,
  IonHeader,
  IonToolbar,
  IonGrid,
  IonRow,
  IonImg,
  IonCol,
  IonContent,
  IonPopover,
  IonSegment,
  IonSegmentButton,
  IonModal,
} from "@ionic/vue";

// REFS

export default /*#__PURE__*/_defineComponent({
  __name: 'UsersAppLayout',
  setup(__props) {

// IONIC / VUE IMPORTS
const appStore = useAppStore();
const authStore = useAuthStore();
const { userData } = storeToRefs(authStore);
const { selectedTab, loginModal } = storeToRefs(appStore);

const route = useRoute();
const email = ref("");
const pass = ref("");
const isInstagram = ref(false);

// METHODS
const login = async () => {
  try {
    if (email.value && pass.value) loginModal.value = false;
    await authStore.loginUser(email.value, pass.value);
    email.value = "";
    pass.value = "";
  } catch (err) {
    console.log(err);
  }
};

const loginWithGoogle = async () => {
  loginModal.value = false;
  await authStore.loginUserWithGoogle();
};

const openStore = (store: "appstore" | "playstore") => {
  if (store == "appstore")
    window.open("https://apps.apple.com/pa/app/one-spot/id1604925208");
  if (store == "playstore")
    window.open(
      "https://play.google.com/store/apps/details?id=com.onespotlive.twa"
    );
};

const modalIsDismissed = () => {
  loginModal.value = false;
};

// COMPUTED
const showSegmentTabs = computed(() => {
  if (route.fullPath == "/tickets") return true;
  else return false;
});

// HOOKS
onBeforeMount(async () => {
  // CHECK IF IS IG BROWSER
  const ua = navigator.userAgent;
  isInstagram.value = ua.indexOf("Instagram") > -1 ? true : false;
  // END CHECK IF IS IG BROWSER
  appStore.$patch({ globalLoading: true });
  await appStore.getAllPublishedEvents();
  appStore.$patch({ globalLoading: false });
});

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonRow), { class: "ion-justify-content-center" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              "size-xl": "8",
              "size-sm": "11",
              "size-xs": "11",
              style: {"padding":"0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { class: "ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(IonImg), {
                        src: require('@/assets/images/app-store-badge.svg'),
                        style: {"width":"100px","cursor":"pointer","display":"inline-block"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (openStore('appstore')))
                      }, null, 8, ["src"]),
                      _createVNode(_unref(IonImg), {
                        src: require('@/assets/images/play-store-badge.svg'),
                        style: {"width":"100px","cursor":"pointer","display":"inline-block"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (openStore('playstore')))
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), { class: "ion-justify-content-center ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), {
                        "size-lg": "8",
                        "size-xs": "12",
                        style: {"padding":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRow), { class: "ion-align-items-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonImg), {
                                src: require('@/assets/images/os-logo.png'),
                                style: {"width":"30px","cursor":"pointer"},
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/'))),
                                alt: "One Spot Logo"
                              }, null, 8, ["src"]),
                              _createElementVNode("div", {
                                style: {"margin-left":"5px","font-size":"16px","cursor":"pointer"},
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/')))
                              }, _hoisted_6),
                              _createVNode(_unref(IonCol)),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                size: "small",
                                color: "dark",
                                id: "click-trigger"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _unref(personCircleOutline),
                                    style: {"font-size":"2em"},
                                    class: "mr-sm"
                                  }, null, 8, ["icon"]),
                                  (!_unref(userData))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Iniciar sesión"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "Mi cuenta"))
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonPopover), {
                                trigger: "click-trigger",
                                "trigger-action": "click",
                                size: "auto"
                              }, {
                                default: _withCtx(() => [
                                  (!_unref(userData))
                                    ? (_openBlock(), _createBlock(_unref(IonContent), {
                                        key: 0,
                                        class: "ion-padding"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonRow), { class: "ion-justify-content-center mb-md" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonCol), null, {
                                                default: _withCtx(() => [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "email",
                                                    class: "form__field",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((email).value = $event))
                                                  }, null, 512), [
                                                    [_vModelText, email.value]
                                                  ]),
                                                  _hoisted_9
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonRow), { class: "ion-justify-content-center mb-md" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonCol), null, {
                                                default: _withCtx(() => [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "password",
                                                    class: "form__field",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pass).value = $event))
                                                  }, null, 512), [
                                                    [_vModelText, pass.value]
                                                  ]),
                                                  _hoisted_10
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_button, {
                                            color: "os-pink",
                                            expand: "block",
                                            size: "small",
                                            class: "mb-sm",
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (login()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Iniciar sesión ")
                                            ]),
                                            _: 1
                                          }),
                                          (!isInstagram.value)
                                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 0,
                                                expand: "block",
                                                color: "medium",
                                                fill: "outline",
                                                size: "small",
                                                class: "mb-md",
                                                onClick: _cache[7] || (_cache[7] = ($event: any) => (loginWithGoogle()))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(IonImg), {
                                                    src: require('@/assets/images/google.svg'),
                                                    class: "mr-sm",
                                                    style: {"width":"20px"}
                                                  }, null, 8, ["src"]),
                                                  _createTextVNode("Google")
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _hoisted_11,
                                          _createElementVNode("div", {
                                            class: "text-caption text-center text-os-blue mt-md mb-md",
                                            style: {"cursor":"pointer"},
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/register-with-email')))
                                          }, _hoisted_13),
                                          _hoisted_14
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_unref(IonContent), {
                                        key: 1,
                                        class: "ion-padding"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_15, [
                                            _createTextVNode(" Bienvenido, "),
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(userData).name), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(userData).email), 1),
                                          _createVNode(_component_ion_button, {
                                            size: "small",
                                            color: "os-pink",
                                            expand: "block",
                                            class: "mb-sm",
                                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/tickets')))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: _unref(ticketOutline),
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createTextVNode(" Mis boletos ")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_button, {
                                            size: "small",
                                            color: "light",
                                            expand: "block",
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(authStore).logoutUser()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Cerrar sesión ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (showSegmentTabs.value)
            ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegment), {
                    value: _unref(selectedTab),
                    modelValue: _unref(selectedTab),
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(selectedTab) ? (selectedTab).value = $event : null))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSegmentButton), { value: "available" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Disponibles")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "consumed" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Consumidos")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "expired" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Expirados")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonModal), {
            "is-open": _unref(loginModal),
            class: "dialog-modal",
            onDidDismiss: _cache[17] || (_cache[17] = ($event: any) => (modalIsDismissed()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_unref(IonRow), { class: "ion-justify-content-center mb-md mt-md" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form__field",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((email).value = $event))
                        }, null, 512), [
                          [_vModelText, email.value]
                        ]),
                        _hoisted_20
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), { class: "ion-justify-content-center mb-md" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form__field",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((pass).value = $event))
                        }, null, 512), [
                          [_vModelText, pass.value]
                        ]),
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  color: "os-pink",
                  expand: "block",
                  size: "small",
                  class: "mb-sm",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (login()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Iniciar sesión ")
                  ]),
                  _: 1
                }),
                (!isInstagram.value)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 0,
                      expand: "block",
                      color: "medium",
                      fill: "outline",
                      size: "small",
                      class: "mb-md",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (loginWithGoogle()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonImg), {
                          src: require('@/assets/images/google.svg'),
                          class: "mr-sm",
                          style: {"width":"20px"}
                        }, null, 8, ["src"]),
                        _createTextVNode("Google")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_22,
                _createElementVNode("div", {
                  class: "text-caption text-center text-os-blue mt-md mb-md",
                  style: {"cursor":"pointer"},
                  onClick: _cache[16] || (_cache[16] = ($event: any) => {
              loginModal.value = false;
              _ctx.$router.push('/register-with-email');
            })
                }, _hoisted_24)
              ])
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})